import { render, staticRenderFns } from "./AuditHistory.vue?vue&type=template&id=65f8db40"
import script from "./AuditHistory.vue?vue&type=script&lang=js"
export * from "./AuditHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports